export default __webpack_public_path__ + "static/media/img_roadmap.d3d09cec.png";